import { generateSymbol } from "./symbol";
import { generateLegend } from './legend';


export {
  generateSymbol,
  generateLegend
};
